const Form048PICSTC = {
    picsTitle: "個人資料收集聲明",
    subtitleList: [
        { text: "收集個人資料的目的" },
        { text: "可獲轉移資料者" },
        { text: "查閱個人資料" },
    ],
    symbolStep: [
        { step: "（a）" },
        { step: "（b）" },
        { step: "（c）" },
        { step: "（d）" },
        { step: "（e）" },
        { step: "（f）" },
        { step: "（g）" },
    ],
    firstStep: [
        {
            text: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        },
        {
            text: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理申請。",
        },
        {
            text: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        },
        {
            text: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向當值主任提出：香港太古城太古灣道14號6樓602室或電郵至 <a href='mailto: jokc@edb.gov.hk'>jokc@edb.gov.hk</a>。",
        },
    ],
    secondStep: [
        {
            text: "處理、核實及查證就發還其他費用的申請；",
        },
        {
            text: "就上文(a)項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
        },
        {
            text: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
        },
        {
            text: "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、評審提名、獎項和獎學金，以及監察達標進度；",
        },
        {
            text: "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
        },
        {
            text: "編製統計資料、研究及政府刊物；以及",
        },
        {
            text: "執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》]。",
        },
    ],
    thirdStep: [
        {
            text: "政府其他政策局及部門，以用於上文第1段所述的用途；",
        },
        {
            text: "與本表格相關的學校，以用於上文第1段所述的用途；",
        },
        {
            text: "你曾就披露個人資料給予訂明同意；以及",
        },
        {
            text: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
    ],
};
export default Form048PICSTC;
